import api from "../../services/api";
import gridClientBase from "../../components/gridClientComponentBase";
import cellTemplate from "../../components/grid/cellTemplate/cellTemplate.vue";
import headerTemplate from "../../components/grid/headerTemplate/headerTemplate.vue";
import moment from "moment";
import formatcoords from "formatcoords";
import helpers from "../../shared/fleetbox-helpers";
import reverseGeocoding from "./reverseGeocoding.vue";
import { bus } from "../../main";
import { mapGetters } from "vuex";

export default {
	extends: gridClientBase,
	components: {
		"reverse-geocoding": reverseGeocoding
	},
	props: {
		data: Array,
		gridClass: String,
		vehicleItemsFilter: Array,
		vehicleSelectedFilter: Array,
		driverItemsFilter: Array,
		driversSelectedFilter: Array,
		statusFilter: Array,
		vehicleIdFilterField: String
	},
	data: function() {
		return {
			statusSelectedFilter: [],
			groupsSelectedFilter: [],
			canExportGridData: false,
			notHasTripsDataPermission: true,
			totalItems: 0
		};
	},

	created() {
		var self = this;

		this.setDefaultTablePageIndexAndSize();
		this.sort = [{ field: "last_event_date", dir: "desc" }];

		if (this.settings && this.settings.canExportGridData) {
			this.canExportGridData = true;
		}

		if (this.scopes && this.scopes.length > 0) {
			this.notHasTripsDataPermission =
				this.scopes.some(item => {
					return item == "TRIPS_DATA";
				}) == false;
		}

		this.hasSelectedMode = true;
		this.items = this.data;

		//Inizialize Filters if already presents
		this.inizializeFilters();

		bus.$on("marker-click", self.markerClickHandler.bind(self));
		bus.$on("filter-head-change", self.onFilterHeadChange.bind(self));
	},
	watch: {
		data: {
			handler() {
				this.items = this.data;
				this.totalItems = this.items.length;
			},
			deep: true
		},
		gridData() {
			if (this.gridData && this.gridData.length) {
				bus.$emit("set-address-to", { source: "horizontalTable", items: this.gridData });
			}
		}
	},
	/* metodi */
	methods: {
		onFilterHeadChange(filters) {
			if (filters.length > 0) {
				for (var i = 0; i < filters.length; i++) {
					let e = filters[i];
					if (e.filterItemsSelected.length > 0) {
						var filterToApply = {
							field: e.field,
							filterType: e.filterType,
							filterItemsSelected: e.filterItemsSelected
						};

						this.filterHandler(filterToApply, true);
					} else {
						this.removeFilter({
							field: e.field
						});
					}
				}
			}
			
			this.setDefaultTablePageIndexAndSize();
		},
		goToTripsData(number_plate, pathId, statusDate, vehicle_id) {
			if (this.notHasTripsDataPermission == false) {
				var startDateFilter = null;

				var lastStatusDate = moment(statusDate);
				var now = moment();
				var timeToOff = "";

				var diff = now.diff(lastStatusDate, "days");
				if (diff == 0) {
					this.$router.push({
						name: "TRIPS_DATA",
						query: {
							vehicleId: number_plate,
							pathId: pathId,
							code: vehicle_id
						}
					});
				} else {
					startDateFilter = lastStatusDate.startOf("day");
					this.$router.push({
						name: "TRIPS_DATA",
						query: {
							vehicleId: number_plate,
							pathId: pathId,
							startDay: startDateFilter.utc().format()
						}
					});
				}
			}
		},
		onUpdateGeocodingAddress(e) {
			this.$emit("update-address-data", {
				id: e.id,
				address: e.address
			});
		},
		internalFiltersToUpdate(e) {
			if (e.field == "status") {
				this.statusSelectedFilter = [];
			}

			this.setDefaultTablePageIndexAndSize();
		},
		internalFiltersAddToUpdate(e) {
			if (e.field == "status") {
				this.statusSelectedFilter = [];
			}

			this.setDefaultTablePageIndexAndSize();
		},
		inizializeFilters() {
			if (this.vehicleSelectedFilter.length > 0) {
				var filtersToAdd = {
					field: this.vehicleIdFilterField,
					type: "multiselect",
					filter: {
						logic: "or",
						filters: []
					}
				};

				for (var i = 0; i < this.vehicleSelectedFilter.length; i++) {
					var f = this.vehicleSelectedFilter[i];
					filtersToAdd.filter.filters.push({
						field: this.vehicleIdFilterField,
						operator: "contains",
						value: f
					});
				}

				this.columnFilters.push(filtersToAdd);
			}
			if (this.driversSelectedFilter.length > 0) {
				var filtersToAdd = {
					field: "driver_name",
					type: "multiselect",
					filter: {
						logic: "or",
						filters: []
					}
				};

				for (var i = 0; i < this.driversSelectedFilter.length; i++) {
					var f = this.driversSelectedFilter[i];
					filtersToAdd.filter.filters.push({
						field: "driver_name",
						operator: "contains",
						value: f
					});
				}

				this.columnFilters.push(filtersToAdd);
			}
		},
		markerClickHandler(e) {
			if (e && e.marker) {
				var itemToSelect = this._.find(this.items, function(x) {
					return x.id === e.marker.id;
				});

				var showItemIndex = this.itemToReturnIfIsInEditMode.findIndex(function(x) {
					return x.id == itemToSelect.id;
				});

				var pageSize = this.take;
				var page = parseInt(showItemIndex / pageSize);

				this.skip = this.take * page;

				if (itemToSelect) {
					this.selectRow(itemToSelect);
				}
			}
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		formattedDate(date) {
			var d = moment(date);

			return d.format("DD/MM/YYYY HH:mm");
		},
		formattedCoordinates(lat, lon) {
			return helpers.formatCoordinate(lat, "lat") + ", " + helpers.formatCoordinate(lon, "lon");
		},
		setDefaultTablePageIndexAndSize() {
			this.skip = 0;
			this.take = 25;
		}
	},
	computed: {
		...mapGetters(["settings", "scopes"]),
		vehiclesFilter() {
			return this.vehicleItemsFilter.map(function(item) {
				return {
					id: item.number_plate,
					value: item.number_plate
				};
			});
		},
		driversFilter() {
			return this.driverItemsFilter.map(function(item) {
				return {
					id: item.id,
					value: `${item.surname} ${item.name}`
				};
			});
		},
		columns: function() {
			return [
				{
					field: this.vehicleIdFilterField,
					title: this.vehicleIdFilterField == "number_plate" ? "targa" : "codice",
					width: "120",
					headerCell: "myLicensePlateHeaderTemplate",
					filterable: true,
					cell: "myCellTemplate"
				},
				{
					field: "vehicle_name",
					title: "modello",
					width: "250",
					headerCell: "myHeaderTemplate",
					filterable: true,
					cell: "myCellTemplate"
				},
				// {
				// 	// field: "vehicle_name",
				// 	title: "gruppo",
				// 	width: "150",
				// 	headerCell: "myHeaderTemplate",
				// 	filterable: true,
				// 	cell: "myCellTemplate"
				// },
				{
					field: "driver_name",
					title: "conducente",
					width: "200",
					headerCell: "myDriverHeaderTemplate",
					filterable: true,
					cell: "myCellTemplate"
				},
				{
					field: "status",
					title: "stato",
					width: "90",
					headerCell: "myStatuseHeaderTemplate",
					filterable: true,
					cell: "myStatusCellTemplate"
				},
				{
					field: "last_event_date",
					title: "data/ora",
					className: "text-center",
					width: "130",
					headerCell: "myDateTimeHeaderTemplate",
					filterable: true,
					cell: "dateCell"
				},
				{
					field: "address",
					title: "posizione",
					className: "",
					width: "450",
					headerCell: "myHeaderTemplate",
					cell: "positionAddress",
					filterable: false
				},
				{
					field: "",
					title: "",
					className: "",
					width: "",
					headerCell: "",
					cell: "",
					filterable: false
				},
				{
					field: "coordinates",
					title: "coordinate",
					className: "text-center",
					width: "140",
					headerCell: "myHeaderTemplate",
					filterable: false,
					sortable: false,
					cell: "positionCoordinates"
				}
			];
		}
	}
};
